import { cn } from "@heroui/react";
import type { ReactNode } from "react";
import InertIcon from "./InertIcon";
import { resolveDemoIcon } from "../icons/defaultIcons";
import type { InboxDemoIconKey, InboxDemoIcons } from "../data/types";

const NAV_ITEMS: { key: InboxDemoIconKey }[] = [
  { key: "builder" },
  { key: "agent" },
  { key: "inbox" },
  { key: "knowledge" },
  { key: "contacts" },
  { key: "discovery" },
  { key: "dashboard" },
  { key: "integrations" },
  { key: "settings" },
];

type GlobalSidebarProps = {
  icons: InboxDemoIcons;
  activeKey?: InboxDemoIconKey;
};

function SidebarSlot({
  children,
  active,
}: {
  children: ReactNode;
  active?: boolean;
}) {
  return (
    <div
      className={cn(
        "flex h-11 w-full items-center justify-center rounded-[14px] text-default-600",
        active && "bg-default-200 text-default-600",
      )}
    >
      {children}
    </div>
  );
}

export default function GlobalSidebar({
  icons,
  activeKey = "inbox",
}: GlobalSidebarProps) {
  return (
    <aside className="hidden h-full w-20 shrink-0 flex-col items-center gap-3 overflow-hidden bg-[var(--inbox-demo-chrome)] px-1.5 pb-6 pt-3 sm:flex">
      <div className="flex h-6 w-full items-center justify-center">
        <InertIcon className="h-6 w-6" label="3Chat">
          {resolveDemoIcon(icons, "logo")}
        </InertIcon>
      </div>
      <div className="flex w-full justify-center">
        <SidebarSlot>
          <InertIcon>{resolveDemoIcon(icons, "search")}</InertIcon>
        </SidebarSlot>
      </div>
      <div className="flex min-h-0 w-full flex-1 flex-col items-center gap-0.5 overflow-y-auto px-1">
        {NAV_ITEMS.map((item) => (
          <SidebarSlot active={item.key === activeKey} key={item.key}>
            <InertIcon>{resolveDemoIcon(icons, item.key)}</InertIcon>
          </SidebarSlot>
        ))}
      </div>
      <div className="flex w-full flex-col items-center">
        <SidebarSlot>
          <InertIcon>{resolveDemoIcon(icons, "support")}</InertIcon>
        </SidebarSlot>
        <SidebarSlot>
          <InertIcon>{resolveDemoIcon(icons, "feedback")}</InertIcon>
        </SidebarSlot>
      </div>
    </aside>
  );
}
